import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Typography } from '@mui/material'
import theme from 'lib/theme'
import { useLocale } from 'providers/LocaleProvider'
import React from 'react'
import { useTranslation } from 'react-i18next'

type CustomHeaderProps = {
  monthDate: Date
  customHeaderCount: number
  decreaseMonth: () => void
  increaseMonth: () => void
}

export const CustomHeader = ({
  monthDate,
  customHeaderCount,
  decreaseMonth,
  increaseMonth,
}: CustomHeaderProps) => {
  const { t } = useTranslation()
  const { selectedLocale } = useLocale()
  const localisedMonthDate = monthDate.toLocaleString(
    selectedLocale?.code || 'en-US',
    {
      month: 'long',
      year: 'numeric',
    }
  )
  return (
    <div style={{ marginBottom: theme.spacing(1) }}>
      <button
        type='button'
        aria-label={t('prevMonth')}
        style={{
          top: theme.spacing(1),
          left: '10px',
          ...(customHeaderCount === 1 && { visibility: 'hidden' }),
        }}
        className='react-datepicker__navigation react-datepicker__navigation--previous'
        onClick={decreaseMonth}>
        <ChevronLeftIcon
          sx={{
            fill: theme.palette.text.secondary,
            width: '20px',
            height: '20px',
          }}
        />
      </button>
      <Typography variant='body2'>{localisedMonthDate}</Typography>
      <button
        type='button'
        aria-label={t('nextMonth')}
        className='react-datepicker__navigation react-datepicker__navigation--next'
        style={{
          top: theme.spacing(1),
          right: '10px',
          ...(customHeaderCount === 0 && { visibility: 'hidden' }),
        }}
        onClick={increaseMonth}>
        <ChevronRightIcon
          sx={{
            fill: theme.palette.text.secondary,
            width: '20px',
            height: '20px',
          }}
        />
      </button>
    </div>
  )
}
